import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MandoobCustomersDeposits } from './mandoobcustomerdeposit.model';
import { Users } from 'src/app/options/users/users.model';
import { Customer } from 'src/app/options/customer.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ReportsService } from '../reports.service';
import { MandoobService } from 'src/app/options/mandoobs/mandoob.service';
import { Globle } from 'src/assets/globle';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-mandoobcustomers-deposits',
  templateUrl: './mandoobcustomers-deposits.component.html',
  styleUrls: ['./mandoobcustomers-deposits.component.css']
})
export class MandoobcustomersDepositsComponent implements OnInit {

  reports: MandoobCustomersDeposits[] = [];
  users: Users[] = [];
  mandoobs: Customer[] = [];

  displayedColumns: string[] = ['customerName', 'customerPhone', 'amount', 'date', 'prevBalance', 'currBalance', 'mandoobPrevBalance', 'mandoobCurrBalance'];
  dataSource!: MatTableDataSource<MandoobCustomersDeposits>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  spinnerOverlay = false;
  selectedUser!: string;
  lang = 'en';
  reportObj: MandoobCustomersDeposits = {} as MandoobCustomersDeposits;
  pageSize = 100;

  constructor(private service: ReportsService,
    private mandoobService: MandoobService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getManddobs();
  }

  getManddobs() {
    this.spinnerOverlay = true;
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)

    })
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getMandoobsCustomersDeposit(this.selectedUser, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {

      this.reports = data;
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalDeposit() {
    return this.reports.filter(x => x.operationByType != 3).map(t => t.amount).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalDetuct() {
    return this.reports.filter(x => x.operationByType == 3).map(t => t.amount).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  // Print() {

  //   const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

  //   doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
  //   doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

  //   doc.setFont("Amiri");

  //   doc.setFontSize(18);
  //   doc.setTextColor(40);
  //   //doc.setFont("",'normal');

  //   doc.text("كشف حركات مستخدم ", 90, 10);
  //   doc.text("_________________________________", 50, 12);

  //   // set font
  //   doc.setFontSize(10);
  //   doc.viewerPreferences({ "Direction": "L2R" }, true);

  //   let userName = this.users.find(x => x.id == this.selectedUser)?.fullName != null ?
  //     this.users.find(x => x.id == this.selectedUser)?.fullName :
  //     this.users.find(x => x.id == this.selectedUser)?.userName;

  //   doc.text(" المستخدم : " + userName, 150, 20, {
  //     isOutputRtl: true,
  //   });

  //   //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
  //   autoTable(doc, { html: '#userTransTable', margin: { top: 30 }, styles: { font: "Amiri" } });
  //   //doc.save("test.pdf");
  //   doc.output('dataurlnewwindow');
  // }


}
